import type { IResultstash } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IPublicKeyInfo } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IFetchEnrolledKeysCriteria {
  limit?: number;
  offset?: number;
}

export interface IFetchEnrolledKeysOpts {
  apiUrl: string;
  apikey?: string;
  ctrl?: QueryController;
  sessionKey: string;
}

export const createRequest = (criteria: IFetchEnrolledKeysCriteria, opts: IFetchEnrolledKeysOpts): Request => {
  const { apiUrl, apikey, sessionKey, ...restOpts } = opts;

  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["signature"]).setQuery(criteria).build();

  const headers = createHeaders({
    /* If the apikey is something else then undefined its added */
    "ARGUS-API-KEY": apikey,
    "ARGUS-CSRF-Token": !apikey ? createCsrfToken(sessionKey, String(uri)) : false,
    Accept: "application/json",
    "Content-Type": "application/json",
  });

  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
    mode: "cors",
  };

  if (!apikey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function fetchEnrolledKeys(criteria: IFetchEnrolledKeysCriteria, opts: IFetchEnrolledKeysOpts) {
  return await fetchJsonQuery<IResultstash<{ keys: IPublicKeyInfo[] }>>(createRequest(criteria, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default fetchEnrolledKeys;
